import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import ConfirmModal from './ConfirmModal';
import ThemeToggle from './ThemeToggle';
import { 
  HomeIcon, 
  ChatBubbleBottomCenterTextIcon, 
  UserCircleIcon, 
  UserGroupIcon, 
  ArrowRightOnRectangleIcon, 
  Bars3Icon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';

function Header({ username, onlineUsers, socket, roomName, onToggleUsers }) {
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleLeaveChat = () => {
    setShowConfirmModal(true);
  };

  const confirmLeave = () => {
    if (socket) {
      socket.disconnect();
    }
    // Keep the nickname in localStorage so user doesn't have to re-enter it
    navigate('/join-room');
  };

  return (
    <>
      <header className="bg-gray-900 border-b border-gray-700 shadow-md sticky top-0 z-50 transition-colors">
        <div className="container mx-auto px-4 py-3">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
            {/* Left section */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center gap-2 px-3 py-2">
                <ChatBubbleBottomCenterTextIcon className="h-6 w-6 text-blue-400" />
                <h1 className="text-xl font-bold text-white">
                  <span className="text-blue-400">Chat</span><span className="text-indigo-400">Sphere</span>
                </h1>
              </div>

              {roomName && (
                <div className="flex items-center gap-2 bg-gray-800/60 dark:bg-gray-800 px-3 py-2 rounded-lg text-white border border-gray-700 shadow-sm">
                  <HomeIcon className="h-5 w-5 text-blue-400" />
                  <span className="text-sm font-medium">
                    Room: <span className="text-blue-300">{roomName}</span>
                  </span>
                </div>
              )}
            </div>

            {/* Right section */}
            <div className="flex items-center space-x-3">
              <div className="hidden sm:flex items-center gap-2 bg-gray-800/60 px-3 py-2 rounded-lg border border-gray-700">
                <UserCircleIcon className="h-5 w-5 text-indigo-400" />
                <span className="text-sm text-gray-300">
                  <span className="text-indigo-300 font-medium">{username}</span>
                </span>
              </div>
              
              <div className="flex items-center gap-2 bg-gray-800/60 px-3 py-2 rounded-lg border border-gray-700 hover:bg-gray-700/60 transition-colors cursor-pointer" 
                onClick={onToggleUsers}
                title="Show online users"
              >
                <UserGroupIcon className="h-5 w-5 text-green-400" />
                <span className="text-sm font-medium text-green-300">
                  {onlineUsers} online
                </span>
              </div>
              
              <ThemeToggle />
              
              <button
                onClick={handleLeaveChat}
                className="flex items-center gap-2 px-3 py-2 bg-red-600/90 hover:bg-red-700 text-white rounded-lg shadow-sm
                text-sm font-medium
                transition-all duration-200 
                hover:shadow-md border border-red-500
                active:scale-95"
                title="Leave this chat room"
              >
                <ArrowRightOnRectangleIcon className="h-5 w-5" />
                <span className="hidden sm:inline">Leave</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {showConfirmModal && (
        <ConfirmModal
          onConfirm={confirmLeave}
          onCancel={() => setShowConfirmModal(false)}
          title="Leave Chat"
          message="Are you sure you want to leave this chat? You'll need to join again to continue chatting."
          confirmText="Yes, Leave"
          cancelText="Cancel"
        />
      )}
    </>
  );
}

export default Header;